export const ArrowIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="23"
    height="24"
    viewBox="0 0 23 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.83182 12.3294C0.12677 11.723 -0.263133 9.42646 1.2314 8.79293L19.7762 0.931742C21.3253 0.275063 23.1612 2.11094 22.5045 3.66006L14.6433 22.2048C14.0098 23.6994 11.7132 23.3094 11.1069 21.6044L9.22793 16.3212C8.88352 15.3528 8.08351 14.5527 7.1151 14.2083L1.83182 12.3294Z"
      fill="currentColor"
    />
  </svg>
);
